import locationFeedApi from 'common/src/modules/locationFeed/locationFeed.api';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {z} from 'zod';
import {CampaignSetupAgentToolName} from '../../../../campaignSetupAgent.enums';

const MAX_LOCATION_FEEDS_COUNT = 10;

const getLocationFeedToolSchema = z.object({
  prompt: z
    .string()
    .describe(
      'As detailed as possible description of the location feed to search for following the user prompt.',
    ),
  maxCount: z.number().describe('The maximum number of location feeds to return'),
});

export default function getLocationFeedTool() {
  async function execute({
    input: {prompt},
  }: ToolExecuteParams<typeof getLocationFeedToolSchema>): Promise<ToolResult> {
    try {
      // Get all feeds
      const searchResponse = await locationFeedApi.searchFeeds(prompt);

      if (!searchResponse.locationFeeds.length) {
        return toolResult(`No location feeds found. Reason: ${searchResponse.filtersExplanation}`);
      }

      const locationFeeds = searchResponse.locationFeeds.slice(0, MAX_LOCATION_FEEDS_COUNT);

      return toolResult(
        JSON.stringify({
          locationFeeds: locationFeeds.map((feed) => ({
            id: feed.id,
            name: feed.name,
          })),
          instructions:
            locationFeeds.length > 1
              ? `More than one location feed found, use the first location feed and ask the user for clarification.`
              : '',
        }),
      );
    } catch (error) {
      return toolError(
        `Error retrieving location feeds: ${
          error instanceof Error ? error.message : 'Unknown error'
        }`,
      );
    }
  }

  return tool({
    name: CampaignSetupAgentToolName.GetLocationFeeds,
    displayName: 'Searching location feeds',
    description: "Search for feeds from account's location feeds library based on a prompt.",
    execute,
    inputSchema: getLocationFeedToolSchema,
  });
}
